import api from '@/plugins/api';
// import router from '@/plugins/router'
import {routerInstance, createNewRoute} from '@/plugins/router';
// import permission from '@/routes/permission-parking'
// 引入系统路由表
import {ROUTERS_PERMISSION} from '@/global/module-config';
// import qs from 'qs'
// import axios from 'axios'
import _ from 'lodash';
import store from '@/plugins/store';

const getMenuList = routes => {
  return routes.filter(route => {
    if (route.meta && route.meta.showInMenu) {
      if (route.children) {
        route.children = getMenuList(route.children);
        if (!route.children.length) {
          delete route.children;
        }
      }
      return true;
    }
    return false;
  });
};

export default {
  login({commit}, loginInfo) {
    commit('clearStore');
    let header = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'application/x-www-form-urlencoded'
      }
    };
    let data = {};
    if (loginInfo) {
      data = {
        username: loginInfo.username,
        password: loginInfo.password
      };
    }
    let username = sessionStorage.getItem('username');
    console.log('account======');
    console.log(username);
    if (!username) {
      username = loginInfo.username;
    }

    let promise = loginInfo ? api['account/login'](data, header) : api['account/getUserInfo']({username: username});
    promise.then(data => {
      console.log('success  getUserInfo====================================');
      console.log(data);
      if (data) {
        commit('setUserInfo', data.account);
        sessionStorage.setItem('username', data.account.username); // 存储用户信息
        sessionStorage.setItem('displayname', data.account.displayName); // 存储用户信息
        commit('setPermissionList', _.cloneDeep(data.permissions));
        let routes = ROUTERS_PERMISSION(data.permissions);
        // router.addRoutes(routes)
        routerInstance.addRoutes(routes);
        commit('setMenuList', getMenuList(_.cloneDeep(routes)));
        commit('setDepartment', data.department);
        commit('setIsAdmin', data.roles);
        api['config/getSysConfig']().then(data => {
          commit('setSystemConfig', data);
        });
      }
    });
    return promise;
  },
  handleLogOut({commit}) {
    let newRouter = createNewRoute();
    routerInstance.matcher = newRouter.matcher;
    commit('clearStore');
    // 执行退出登录
    api['account/logout']().then(data => {
    });
  },
  getUnreadMessageCount() {
    // 获取未读信息数量
  },
  loginFun() {
  }

  // updateUserInfo ({ commit }) {
  //   api['common/userInfo']().then(data => {
  //     commit('setUserName', data.userName)
  //   })
  // }
};
